"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectLine = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "name", "form", "label", "placeholder", "options", "disabled", "errorMessage", "optional", "helper"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var StyledSelectLineDiv = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-nv6naw-0"
})(["position:relative;width:100%;select{", " border-radius:0;box-sizing:border-box;padding:14px 14px 14px 0;border-width:0 0 1px 0;", " ", " cursor:pointer;}.helper-error{", " ", "}"], _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'interactive-alternate'), function (props) {
  return props.hasError && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('border-color: ', 'error'));
}, _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-placeholder'), function (props) {
  return props.hasError && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'error'));
});
var SelectLine = exports.SelectLine = function SelectLine(_ref) {
  var className = _ref.className,
    name = _ref.name,
    form = _ref.form,
    label = _ref.label,
    placeholder = _ref.placeholder,
    options = _ref.options,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    optional = _ref.optional,
    helper = _ref.helper,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var hasError = Boolean(errorMessage);
  var required = moreProps.required;
  var props = _objectSpread(_objectSpread({}, moreProps), {}, {
    hasError: hasError
  });
  var selectOptions = options || [];
  var optionsData = selectOptions.map(function (option) {
    var id = option.text.toLowerCase().replace(/ /g, '_');
    id = "".concat(name || '', "_").concat(id);
    return {
      id: id,
      text: option.text,
      value: option.value
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_index.Space, _extends({
    size: "small",
    direction: "vertical",
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "small",
    justify: "space-between",
    className: "k-ds-width-full",
    direction: "horizontal"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "k-ds-heading-02 k-ds-text-color-primary",
    htmlFor: name
  }, label, required ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-text-color-error"
  }, ' *') : null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-label-01 k-ds-text-color-interactive-secondary"
  }, optional)), /*#__PURE__*/_react["default"].createElement(StyledSelectLineDiv, {
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "k-ds-body-02",
    defaultValue: "",
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("option", {
    key: placeholder,
    id: placeholder,
    name: name,
    disabled: true,
    value: "",
    form: form
  }, placeholder), selectOptions.length > 0 ? optionsData.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.id,
      id: option.id,
      name: name,
      value: option.value,
      form: form
    }, option.text);
  }) : null), helper || hasError ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "helper-error k-ds-caption-01"
  }, errorMessage || helper) : null));
};